import { type Dayjs } from "dayjs";

export interface Equipment {
  id: number;
  parks: { id: number }[];
}

export enum HistoryType {
  ProductTest = "ProductTest",
  Allotment = "Allotment",
  Movement = "Movement",
  Booking = "Booking",
}

export interface History {
  id: number;
  equipment_id: number;
  type: HistoryType;
  start_at: string;
  end_at: string;
  resource: object;
  // Ajoutez d'autres propriétés selon vos besoins
}
export interface Tour {
  slug: string;
  id: number;
  start_at: string;
  end_at: string;
  parks: { id: number }[];
  stages: { parks: { id: number }[] }[];
}

export interface CalendarEvent {
  date: Date;
  type: string;
  resource: object;
}

const getHistoryCalendarPosition = (historyStartAt: Dayjs, historyEndAt: Dayjs|null, calendarStartAt: Dayjs, calendarEndAt: Dayjs) => {
  const calendarStart = calendarStartAt.clone().startOf('day');
  const calendarEnd = calendarEndAt.clone().endOf('day');
  const historyStart = historyStartAt.isBefore(calendarStartAt)
    ? calendarStart.clone() // historyStartAt is before calendarStartAt
    : historyStartAt.clone().startOf('day'); // reset time to 00:00:00
  let historyEnd = !historyEndAt
  ? calendarEnd.clone() // no historyEndAt, set to calendarEndAt
  : historyEndAt.hour() === 0 && historyEndAt.minute() === 0 && ! historyEndAt.isSame(historyStart, 'day') // historyEndAt is 00:00:00 and not same day as historyStartAt
    ? historyEndAt.clone().subtract(1, 'day').endOf('day') // Set to 23:59:59 of the day before
    : historyEndAt.clone().endOf('day'); // reset time to 23:59:59

  historyEnd = historyEnd > calendarEnd
    ? calendarEnd.clone() // historyEndAt is after calendarEndAt
    : historyEnd.clone().endOf('day') // reset time to 23:59:59

  return {
    start: historyStart.date(),
    end : historyEnd.date()
  }
}

const getCalendarEventsFromHistory = (equipments: Equipment[], histories: History[], tours: Tour[]): { [key: number]: CalendarEvent[] } => {
  const calendars: { [key: number]: CalendarEvent[] } = equipments.reduce((calendars, equipment: Equipment) => {
    calendars[equipment.id] = [];
    tours.forEach((tour: Tour) => {
      let isAssociatedToTour = tour.parks.some((park) => {
        return equipment.parks.some((equipmentPark) => {
          return equipmentPark.id === park.id
        })
      })
      let isAssociatedToStage = tour.stages.some((stage) => {
        return equipment.parks.some((equipmentPark) => {
          return stage.parks.some((stagePark) => {
            return equipmentPark.id === stagePark.id
          })
        })
      })
      if(!isAssociatedToTour && !isAssociatedToStage) {
        return;
      }

      // get all dates between start_at and end_at
      const start = new Date(tour.start_at);
      const end = new Date(tour.end_at);
      const diff = end.getTime() - start.getTime();
      const days = diff / (1000 * 60 * 60 * 24);
      for (let i = 0; i <= days; i++) {
        const date = new Date(start.getTime() + i * 24 * 60 * 60 * 1000);

        calendars[equipment.id].push(<CalendarEvent>{
          date,
          type: 'Tour',
          resource: tour
        });
      }
    });
    return calendars;
  }, {});

  histories.forEach((history: History) => {
    // get all dates between start_at and end_at
    const start = new Date(history.start_at);
    const end = new Date(history.end_at);
    const diff = end.getTime() - start.getTime();
    const days = diff / (1000 * 60 * 60 * 24);
    for (let i = 0; i <= days; i++) {
      const date = new Date(start.getTime() + i * 24 * 60 * 60 * 1000);

      if (!calendars[history.equipment_id]) {
        calendars[history.equipment_id] = [];
      }

      calendars[history.equipment_id].push(<CalendarEvent>{
        date,
        type: history.type,
        resource: history.resource
      });
    }
  })

  return calendars;
}

export {
  getCalendarEventsFromHistory,
  getHistoryCalendarPosition,
};